module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-dark-sm-fa3362f654061f40d0e3932887f690b8.png";